import PageContent from './components/PageContent'

const Dashboard = () => (
  <PageContent />
)

export default Dashboard
